import { z } from 'zod'

import { PAGE_FORMAT } from '@hashnode/database-schema'
import { visibilitySchema } from './shared'

// PAGE WITH FRONT MATTER CONTENTS
export const basePageContentSchema = z.object({
	slug: z.optional(z.string()).nullable(),
	ogImage: z.optional(z.string()).nullable(),
	title: z.optional(z.string()).nullable(),
	description: z.optional(z.string()).nullable(),
	content: z.optional(z.string()).nullable(),
	seoTitle: z.optional(z.string()).nullable(),
	seoDescription: z.optional(z.string()).nullable(),
	visibility: visibilitySchema,
	label: z.optional(z.string()).nullable(),
	format: z.optional(z.enum(PAGE_FORMAT)),
	numberOfMatterLines: z.number().nullable().default(0),
})

export type ParsedPageContentConfig = z.infer<typeof basePageContentSchema>
